import type {Partition} from "@common-core/web-component-runtime/runtime";

import type {Deployment} from "../config";

/**
 * Maps Bridge (deployment, partition) to the `bb_env` key expected by the
 * external Bridge Bar components (notifications, support menu) — the keys
 * are defined in PPE-CoreDomain/notifications .../bridgebar-notifications/environment.ts.
 */
const BB_ENV_MAP: Record<Deployment, Record<Partition, string>> = {
  dz: {"non-prod": "dz_np", "prod": "dz_prod"},
  live: {"non-prod": "qa", "prod": "prod"}
};

/** Resolves the external-component `bb_env` key from (deployment, partition). */
export function getBbEnv(
  deployment: Deployment,
  partition: Partition
): string | undefined {
  return BB_ENV_MAP[deployment]?.[partition];
}
